module.exports = __webpack_public_path__ + "img/icon-about@3x.cee13d13.png";